import { render, staticRenderFns } from "./MaterialGoods.vue?vue&type=template&id=235a3454&scoped=true"
import script from "./MaterialGoods.vue?vue&type=script&lang=js"
export * from "./MaterialGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a3454",
  null
  
)

export default component.exports